import { IV_LENGTH } from './constants';

// Utils functions which returns null if the key is valid
// or an error message if the key is invalid
export const validateKey = (key: string, algorithm: string): null | string => {
	const keyLength = +algorithm.split('-')[1] / 8;

	if (key?.length === keyLength) return null;
	return 'keyLengthError';
};

export const validateIV = (iv: string): null | string => {
	if (iv.length === IV_LENGTH) return null;
	return 'ivLengthError';
};
